import React from 'react'
import { ows_catalog } from '../../../../escalas/ows/ows.catalog'


// used at src\doctorViews\expedientes\visitas-details\escalas-emt.jsx# line 252

// Example of ows data structure: [ 0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2, 3, 0, 1, 2 ]

// Responses: [Ausente, Leve, Moderado, Severo]

const rss = ["Ausente", "Leve", "Moderado", "Severo"]

function getOwsInterpretation(score) {
  if (score <= 15) return 'Sin abstinencia significativa'
  if (score <= 31) return 'Abstinencia leve'
  if (score <= 60) return 'Abstinencia moderada'
  return 'Abstinencia severa'
}

export default function OwsResults({ows}) {
  if (!ows) return null

  const score = ows.reduce((a, v) => a + v, 0)

  return (
    <div>
      <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
        <td><strong>Puntuación total: {score} / 93</strong></td>
        <td><strong>{getOwsInterpretation(score)}</strong></td>
      </tr>
      {ows_catalog.map((pr, i) => (
        <tr key={i} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: i % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
          <td>{pr}</td>
          <td>{rss[ows[i]]}</td>
        </tr>
      ))}
    </div>
  )
}
